import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ManageService } from '../../services/manage.service';
import { AnnuityItemsViewModel } from '../../models/annuity-view.model';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { CommonService } from '../../services/common.service';
import { CspTransitionSkuPipe } from '../../shared/pipes/sku-pipe';
import { GetProductPricingV2 } from '../../models/csp.model';

@Component({
  selector: 'confirm-upgrade-pop-up',
  templateUrl: './confirm-upgrade-pop-up.component.html',
  styleUrls: ['./confirm-upgrade-pop-up.component.css']
})
export class ConfirmUpgradePopUpComponent implements OnInit {

  private productList:  AnnuityItemsViewModel[];
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  public loading: boolean = false;
  public product: GetProductPricingV2;
  public newTermAmount: number;
  public currenAmount: number;
  public additionalAmount: number;
  public nextBillingAmount: number;

  constructor(
    private cspTransitionSkuPipe: CspTransitionSkuPipe,
    private manageService: ManageService,
    private cs: CommonService,
    public dialogRef: MatDialogRef<ConfirmUpgradePopUpComponent>,
    
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    if (this.data?.tenantId) {
      const stock = this.cspTransitionSkuPipe.transform(this.data?.catalogItemId);
      const sku = `${this.data?.term}:${stock}`;
      this.loading = true;
      this.manageService
        .GetProductPricingList([sku], 'Y')
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe({
          next: (result: GetProductPricingV2[]) => {

            if (this.data?.term && this.data?.catalogItemId) {
              const immediatelyQty = this.cs.toNumber(this.data?.toQty) < this.cs.toNumber(this.data?.originalProduct?.out_confirmed_qty) ? this.cs.toNumber(this.data?.toQty) : this.cs.toNumber(this.data?.originalProduct?.out_confirmed_qty);
              if (!result?.length) this.cs.implementToast(`${sku} not found`, 'Error');
              this.product = result[0];

              this.newTermAmount = this.cs.toNumber(this.data?.toQty)  * this.cs.toNumber((this.product?.out_current_price).replace('$', '').replace(',', ''));
              this.currenAmount = immediatelyQty * this.cs.toNumber((this.data?.originalProduct?.out_price).replace('$', '').replace(',', ''));
              
              let remainingDays = this.cs.getDateDiffInDays(new Date(), new Date(this.data?.commitmentEndDate));

              let totalDaysInCurrentTerm = 0;
              if (this.data?.term == 'P1Y') {
                totalDaysInCurrentTerm = 365;
              } else if (this.data?.term == 'P1M') {
                totalDaysInCurrentTerm = this.cs.getNumnerOfDaysInCurrentMonth();
              }

              this.additionalAmount = (this.newTermAmount * (remainingDays / totalDaysInCurrentTerm)) - (this.currenAmount * (remainingDays / totalDaysInCurrentTerm));

              
              this.nextBillingAmount = this.newTermAmount + this.additionalAmount;
            }
          },
          error: (error: string) => this.cs.implementToast(error, 'Error'),
          complete: () => this.loading = false
        });
    }
  }

  scheduleOnRenewal(): void {
    this.dialogRef.close({ action: 'ScheduleNew', product: this.product });
  }
  
  immediately(): void {
    this.dialogRef.close({ action: 'Immediately' });
  }

  // cancel(): void {
  //   this.dialogRef.close({action: 'Close'});
  // }

  onNoClick(): void {
    this.dialogRef.close({action: 'Close'});
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}
